module.exports = {"620123100":"城关镇","620123101":"夏官营镇","620123102":"高崖镇","620123103":"金崖镇","620123104":"和平镇","620123105":"甘草店镇","620123106":"青城镇","620123107":"定远镇","620123200":"来紫堡乡","620123201":"三角城乡","620123202":"小康营乡","620123203":"连搭乡","620123204":"银山乡","620123205":"马坡乡","620123206":"新营乡","620123207":"清水驿乡","620123208":"龙泉乡","620123209":"韦营乡","620123210":"中连川乡","620123211":"贡井乡","620123212":"园子岔乡","620123213":"上花岔乡","620123214":"哈岘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620123.json
// module id = 2686
// module chunks = 0